import { FormEvent, useState } from 'react';
import { useLang } from 'hooks/lang';

import { IconButton } from 'components/Blocks';
import { ArrowLeftIcon } from 'components/Icons';

import { CodeInput } from './CodeInput';
import { FormWrapper } from '../FormWrapper';

import { useAuth } from 'providers/Auth';
import { useToast } from 'providers/Toast';

import { COMMON_MESSAGES } from 'utils/messages';

const CODE_LENGTH = 6;

export function ConfirmationCode() {
  const [code, setCode] = useState('');

  const [loading, setLoading] = useState(false);

  const { finishLogin, navigateToLogin } = useAuth();
  const { addToast } = useToast();
  const { t } = useLang();

  const handleCodeSubmit = async (formEvent: FormEvent) => {
    formEvent.preventDefault();

    const anyError = [!code || code.length !== CODE_LENGTH].some(Boolean);

    if (anyError) return addToast(COMMON_MESSAGES.makeSureFilling(t));

    setLoading(true);

    const success = await finishLogin({ code });

    if (!success) setLoading(false);
  };

  return (
    <FormWrapper loading={loading} onSubmit={handleCodeSubmit} buttonText={t('login')}>
      <IconButton onClick={navigateToLogin} className="absolute -left-2.5 -top-2.5">
        <ArrowLeftIcon />
      </IconButton>

      <p className="text-xl">
        {t('we-have-sent-the-code-to-your')} <span className="text-primary">{t('slack')}</span>
      </p>

      <CodeInput onChange={setCode} />
    </FormWrapper>
  );
}
